<template>
	<div id="cl-chart-modal-widget">
		<div class="tab-nav">
			<span v-if="hasGrowthChart">
				<a
					:class="isGrowthSelected ? 'selected-tab' : ''"
					@click="emitChangeTab('growth')"
				>Growth of $10K</a>
				<span>|</span>
			</span>
			<a
				:class="isAnnualSelected ? 'selected-tab' : ''"
				@click="emitChangeTab('annual')"
			>Annual Returns</a>
			<span v-if="olderThan10Years">
				<span>|</span>
				<a
					:class="isVolatilitySelected ? 'selected-tab' : ''"
					@click="emitChangeTab('volatility')"
				>Volatility & Returns</a>
			</span>
			<button class="close-button" @click="emitCloseModal">×</button>
		</div>
		<div class="select-nav-container">
			<select class="select-nav" @change="selectTab">
				<option value="annual" :selected="isAnnualSelected">Annual Returns</option>
				<option value="volatility" :selected="isVolatilitySelected">Volatility & Returns</option>
				<option v-if="hasGrowthChart" value="growth" :selected="isGrowthSelected">Growth of $10K</option>
			</select>
			<button class="close-button" @click="emitCloseModal">×</button>
			<a class="close-link" @click="emitCloseModal">CLOSE</a>
		</div>
		<volatility-large-chart
			v-if="isVolatilitySelected"
			:volatilityChart="volatilityChart"
			:volatilityEquityChart="volatilityEquityChart"
			:volatilityFixedIncomeChart="volatilityFixedIncomeChart"
			:volatilityEquityChartData="volatilityEquityChartData"
			:volatilityFixedIncomeChartData="volatilityFixedIncomeChartData"
			:volatilityChartData="getVolatilityChartData"
			:audience="getAudience"
			:widgetData="widgetData"
		>
			<template #volatilityIndexId>
				<slot name="volatilityIndexId"/>
			</template>
			<template #standardDeviation>
				<slot name="standardDeviation"/>
			</template>
			<template #superscript3>
				<slot name="superscript3"/>
			</template>
			<template #superscript4>
				<slot name="superscript4"/>
			</template>
			<template #superscript5>
				<slot name="superscript5" />
			</template>
		</volatility-large-chart>
		<returns-large-chart
			v-if="isAnnualSelected"
			:returnsChart="returnsChart"
			:returnsChartData="returnsChartData"
			:returnsChartNav="returnsChartNav"
			:returnsChartNavData="returnsChartNavData"
			:inceptionDate="inceptionDate"
			:maxDate="maxDate"
			:fundName="fundName"
			:indexName="indexName"
			:widgetData="widgetData"
		>
			<template #annualReturnsIndexId>
				<slot name="annualReturnsIndexId"/>
			</template>
			<template #superscript1>
				<slot name="superscript1"/>
			</template>
			<template #superscript2>
				<slot name="superscript2"/>
			</template>
		</returns-large-chart>
		<growth-large-chart v-if="isGrowthSelected" :widgetData="growthData">
			<template #superscript6>
				<slot name="superscript6"/>
			</template>
			<template  #superscript7>
				<slot name="superscript7"/>
			</template>
			<template #growthIndexId>
				<slot name="growthIndexId"/>
			</template>
		</growth-large-chart>
	</div>
</template>

<script>
import VolatilityLargeChart from './VolatilityLargeChart';
import ReturnsLargeChart from './ReturnsLargeChart';
import GrowthLargeChart from './GrowthLargeChart';
import * as utils from '../../../shared/utils/utils';
export default {
	name: 'chartModalContent',
	components: {
		VolatilityLargeChart,
		ReturnsLargeChart,
		GrowthLargeChart
	},
	props: [
		'volatilityChart',
		'volatilityEquityChart',
		'volatilityFixedIncomeChart',
		'volatilityEquityChartData',
		'volatilityFixedIncomeChartData',
		'volatilityChartData',
		'selectedTab',
		'returnsChart',
		'returnsChartData',
		'returnsChartNav',
		'returnsChartNavData',
		'inceptionDate',
		'maxDate',
		'fundName',
		'indexName',
		'growthData',
		'audience',
		'widgetData'
	],
	data() {
		return {};
	},
	computed: {
		isVolatilitySelected() {
			const tab =
				this.selectedTab ||
				(this.widgetData && this.widgetData.selectedTab) ||
				'';
			return tab == 'volatility';
		},
		isAnnualSelected() {
			const tab =
				this.selectedTab ||
				(this.widgetData && this.widgetData.selectedTab) ||
				'';
			return tab == 'annual';
		},
		isGrowthSelected() {
			const tab =
				this.selectedTab ||
				(this.widgetData && this.widgetData.selectedTab) ||
				'';
			return tab == 'growth';
		},
		getAudience() {
			return this.audience;
		},
		getVolatilityChartData() {
			return this.volatilityChartData || {};
		},
		olderThan10Years() {
			let inceptionDate =
				this.widgetData && this.widgetData.inceptionDate;
			inceptionDate =
				inceptionDate ||
				(this.volatilityChartData &&
					this.volatilityChartData.inceptionDate);
			return utils.olderThan10Years(inceptionDate);
		},
		hasGrowthChart() {
			return this.growthData;
		}
	},
	mounted() {},
	methods: {
		emitChangeTab(tab) {
			this.$parent.$emit('change-tab', tab);
		},
		emitCloseModal() {
			this.$parent.$emit('close-modal');
		},
		selectTab(e) {
			const target = e.currentTarget;
			const tab = target.value;
			this.emitChangeTab(tab);
		}
	}
};
</script>

<style scoped lang='less'>
#cl-chart-modal-widget {
	margin: auto;
	max-width: 1002px;
	padding: 15px;
	.tab-nav {
		@height: 30px;
		display: flex;
		margin: 10px 0px;
		padding-bottom: 10px;
		border-bottom: 1px solid gray;
		font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
		a {
			line-height: @height;
			&.selected-tab {
				color: black;
				text-decoration: none;
				&:hover {
					text-decoration: none;
				}
			}
		}
		span {
			padding-right: 5px;
			padding-left: 5px;
			line-height: @height;
		}
	}
	.close-button {
		margin-left: auto;
		height: 30px;
		background-color: #fff;
		border: none;
		color: #000;
		font-size: 21px;
		font-weight: 700;
		opacity: 0.2;
	}
	.select-nav-container {
		border-bottom: 1px solid #999;
		display: none;
		padding: 20px 0;
		.select-nav {
			border: 1px solid #ccc;
			color: #333;
			font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
			height: 30px;
			max-width: 70%;
			padding: 4px 6px;
			width: 220px;
		}
		.close-button {
			float: right;
		}
		.close-link {
			float: right;
			line-height: 32.5px;
		}
	}
	@media (max-width: 480px) {
		.tab-nav {
			display: none;
		}
		.select-nav-container {
			display: block;
		}
	}
}
</style>
